// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { MixStrength } from './mix-strength';
import { ProductCategory } from './product-category';
import { ProductLocation } from './product-location';
import { ProductMaterial } from './product-material';
import { ProductUnitOfMeasure } from './product-unit-of-measure';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Product extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Types = {
    Delivery: 1884,
  };
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  basePrice!: number;
  categoryId!: number;
  cost!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  deliveryProductId?: number;
  description?: string;
  inventoryUomId?: number;
  locationId!: number;
  materialId!: number;
  mixStrengthId?: number;
  notes?: string;
  partNumber?: string;
  priceUomId?: number;
  shrinkPercentage?: number;
  category!: ProductCategory;
  deliveryProduct!: Product;
  inventoryUom!: ProductUnitOfMeasure;
  location!: ProductLocation;
  material!: ProductMaterial;
  mixStrength!: MixStrength;
  priceUom!: ProductUnitOfMeasure;
}

